//奖励领取状态
export const REWARD_TYPE = {
  UNCLAIMED: 1, //待领取
  CLAIMED: 2, //已领取
  NOT_UNLOCKED: 0, //未解锁
};

//周期任务执行状态
export const TASK_STATE_TYPE = {
  CLAIM: 1, //完成待领取奖励
  IN_PROGRESS: 0, //进行中
  CLAIMED: 2, //已完成已领取奖励
};

//奖励领取状态
export const DRAW_CLICK_TYPE = {
  REWARD: 1, //来自reward的提取
  MESSION: 2, //来自mission的提取
  OG_REWARD: 3, //来自OG的奖励领取
};

//周任务switchTag
export const MISSION_SWITCH_TYPE = {
  TASK: 1,
  OG: 2
}

// 错误文本
export const ERROR_TEXT = {
  NEXTWORK_ERROR: "Network error, please try again later.",
};

//周任务，弹窗类型
export const POPUP_TYPE = {
  UPGRADE: 0,
  PROP: 1,
  ERROR: 2,
  OG_CONGRATULATE: 3,
  OG_HOWTOBE: 4,
  INTRO: 5,
}